enum EnableGuestWeb {
  successful = 'successful',
  tokenInvalid = 'tokenInvalid',
  failed = 'failed',
}

export default EnableGuestWeb;
